export const ACTION__APP__OPEN_IMAGE_MODAL = 'ACTION__APP__OPEN_IMAGE_MODAL';
export const ACTION__APP__CLOSE_IMAGE_MODAL = 'ACTION__APP__CLOSE_IMAGE_MODAL';
export const ACTION__APP__SHOW_CONVERSATION_LIST = 'ACTION__APP__SHOW_CONVERSATION_LIST';
export const ACTION__APP__SET_PLATFORM = 'ACTION__APP__SET_PLATFORM';



// WEBPACK FOOTER //
// ./src/modules/app/actions/types.js